// NOTE: Taken from AC.
import React, { useState } from 'react';
import classnames from 'classnames';
import styled from '@emotion/styled';
import ChevronRight from '@atlaskit/icon/glyph/chevron-right';
import Button from '@atlaskit/button';
import './custom-expand-panel.scss';

export interface CustomExpandPanelProps {
  isDefaultExpanded?: boolean;
  toggleButtonOnLeft?: boolean;
  toggleButtonPrefix?: React.ReactNode;
  toggleButtonSuffix?: React.ReactNode;
  heading: React.ReactNode;
  onChange?: (isExpanded: boolean) => void;
  children?: React.ReactNode;
  testId?: string;
  headerClassname?: string;
  containerClassname?: string;
}

const ToggleButtonWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const CustomExpandPanel = ({
  heading,
  onChange,
  children,
  testId = 'custom-expand-panel',
  isDefaultExpanded = false,
  toggleButtonOnLeft = false,
  toggleButtonPrefix,
  toggleButtonSuffix,
  containerClassname,
  headerClassname,
}: CustomExpandPanelProps) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(isDefaultExpanded);
  const handleExpandCollapse = () => {
    onChange?.(!isExpanded);
    setIsExpanded(!isExpanded);
  };
  const toggleButton = (
    <ToggleButtonWrapper>
      {toggleButtonPrefix}
      <Button
        iconBefore={
          <div className={classnames('custom-panel-icon', { expanded: isExpanded })}>
            <ChevronRight size="medium" label="expand-collapse" />
          </div>
        }
        appearance="subtle"
        testId="expand-collapse-btn"
      />
      {toggleButtonSuffix}
    </ToggleButtonWrapper>
  );

  return (
    <div className="custom-expand-panel" data-testid={testId}>
      <div
        className={classnames(
          'flex align-center',
          {
            'justify-space-between': !toggleButtonOnLeft,
          },
          headerClassname
        )}
        onClick={handleExpandCollapse}
      >
        {toggleButtonOnLeft ? (
          <>
            {toggleButton}
            {heading}
          </>
        ) : (
          <>
            {heading}
            {toggleButton}
          </>
        )}
      </div>

      <div className={classnames('custom-panel-container', { expanded: isExpanded }, containerClassname)}>
        {children}
      </div>
    </div>
  );
};
